export const courseDates = {
    c1_tue: ["2026-05-05", "2026-05-12", "2026-05-19", "2026-05-26", "2026-06-02", "2026-06-09", "2026-06-16", "2026-06-23"],
    c1_wed: ["2026-05-06", "2026-05-13", "2026-05-20", "2026-05-27", "2026-06-03", "2026-06-10", "2026-06-17", "2026-06-24"],
    c2_tue: ["2026-07-07", "2026-07-14", "2026-07-21", "2026-07-28", "2026-08-04", "2026-08-11", "2026-08-18", "2026-08-25"],
    c2_wed: ["2026-07-08", "2026-07-15", "2026-07-22", "2026-07-29", "2026-08-05", "2026-08-12", "2026-08-19", "2026-08-26"],
    c3_tue: ["2026-09-01", "2026-09-08", "2026-09-15", "2026-09-29", "2026-10-06", "2026-10-13", "2026-10-20", "2026-10-27"],
    c3_wed: ["2026-09-09", "2026-09-16", "2026-09-30", "2026-10-07", "2026-10-14", "2026-10-21", "2026-10-28", "2026-11-04"]
};

export const holidays = [
    "2026-07-15", "2026-07-21", "2026-07-22",
    "2026-08-18", "2026-08-19",
    "2026-08-25", "2026-08-26",
    "2026-09-02",
    "2026-09-22", "2026-09-23" // Also adding these to holidays just in case
];

export const allTuesdays = [...courseDates.c1_tue, ...courseDates.c2_tue, ...courseDates.c3_tue];
export const allWednesdays = [...courseDates.c1_wed, ...courseDates.c2_wed, ...courseDates.c3_wed];
export const allSaturdays = ["2026-07-18"];

